import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { ProductSupplier } from '@softapps/wws/core';
import { inject, Injectable } from '@angular/core';
import {
  SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIERS,
} from '../artikelstamm.api';
import { ProductQuery } from '../types/product.query';

@Injectable()
export class SupplierRepository extends ReadonlyHttpApiListRepository<ProductSupplier[], ProductQuery> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIERS);
  }

  override getLoadPathParams(params: ProductQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
